import React from 'react';

import { DuplicatePartsPanel } from '../../../../components/molecules/DuplicatePartsPanel';

import { DuplicatePartsFragmentProps } from '.';

export const DuplicatePartsFragment: React.FC<DuplicatePartsFragmentProps> = ({
  duplicatePartsData,
  mainPartId
}) => {
  return (
    <DuplicatePartsPanel duplicatePartsData={duplicatePartsData} mainPartId={mainPartId} />
  );
};